((d, i, m) => {
    const ct = t => d.createTextNode(t);
    const ce = e => d.createElement(e);

    d.querySelectorAll(i).forEach(e => {
        const a = ce('a');
        const div = ce('div');
        const p = ce('p');
        const s = e.dataset.cookieblockSrc;

        const sp =
            /google\.com\/maps\/embed/.test(s) ? 'Google Maps' :
            /player\.vimeo\.com\/video\//.test(s) ? 'Vimeo' :
            /youtube(-nocookie)?\.com\/embed\//.test(s) ? 'YouTube' :
            undefined;

        if (!sp) return;

        div.innerHTML =
            `<div style="background-color:#CCC;display:inline-block;height:${e.height}px;position:relative;width:${e.width}px;">
                <div style="background-color:#848484;border-radius:15px;height:50%;position:absolute;transform:translate(50%,50%);width:50%;">
                    <p style="color:#FFF;font-size:7.5em;position:relative;top:50%;left:50%;margin:0;text-align:center;transform:translate(-50%,-50%);">
                        &ctdot;
                    </p>
                </div>
            </div>`;

        div.classList.add(`cookieconsent-optout-${m}`);

        a.textContent = cookiebotTexts.message.replace('%s', sp);
        a.href = 'javascript:Cookiebot.renew()';

        p.append(a);

        div.append(p);

        e.parentNode.insertBefore(div, e);
    });
})(document, 'iframe[data-cookieblock-src]', 'marketing');
